import refreshicon from "./refreshicon.svg";

export default function RefreshIcon() {
  return (
    <img src={refreshicon} />
  );
}